// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[dir=ltr] .ck-editor ul {\n  padding-left: 18px;\n}[dir=rtl] .ck-editor ul {\n  padding-right: 18px;\n}\n", ""]);
// Exports
module.exports = exports;
